import { Fragment } from "react";
import { cn } from "@/lib/utils";
import { Card } from "./Card";

const TONE = { red: "text-os-red", amber: "text-os-amber", green: "text-os-green", neutral: "text-os-ink" };

// parts: [{ key, text, tone: red|amber|green|neutral }]; tone "quiet" relaxes the whole strip. `meta` sits top-right.
export const SummaryStripBase = ({ parts, tone, text, size = "lg", separator = " · ", testId = "summary-strip", meta }) => {
  const quiet = tone === "quiet";
  return (
    <Card as="section" data-testid={testId} data-tone={tone} aria-label={text} className={cn("flex items-start justify-between gap-4", size === "lg" ? "px-7 py-5" : "px-5 py-4")}>
      <p
        data-testid={`${testId}-text`}
        className={cn(
          "min-w-0 tabular-nums tracking-[-0.02em]",
          quiet ? "font-normal" : "font-semibold",
          size === "lg" ? "text-[1.75rem] leading-tight" : "text-[1.375rem] leading-snug",
        )}
      >
        {parts.map((part, i) => (
          <Fragment key={part.key}>
            {i > 0 && <span className="font-normal text-os-ink-4">{separator}</span>}
            <span className={TONE[part.tone]}>{part.text}</span>
          </Fragment>
        ))}
      </p>
      {meta}
    </Card>
  );
};
